namespace TabAurous.Sales {
    export namespace CategoryWiseSalesService {
        export const baseUrl = 'Sales/CategoryWiseSales';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/CategoryWiseSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>CategoryWiseSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
